import script from "./box.vue?vue&type=script&setup=true&lang=js"
export * from "./box.vue?vue&type=script&setup=true&lang=js"

import "./box.vue?vue&type=style&index=0&id=767a7434&scoped=true&lang=sass"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-767a7434"]])

export default __exports__